const usersEn = {
    profile: require('../../lang/en/users/Profile').default,
    staff: require('../../lang/en/users/Staff').default,
    assignDepartment: require('../../lang/en/users/AssignDepartment').default,
};

export default usersEn;